import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

const OpenAiPage = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_private/integrations/open-ai/")({
  beforeLoad: () => {
    throw redirect({ to: "/integrations/open-ai/prompts" });
  },
  component: OpenAiPage,
});
